<template>
  <aside
    class="auth-brand-panel"
    data-testid="auth-brand-panel"
    :aria-label="carouselLabel"
    aria-roledescription="carousel"
  >
    <div
      class="auth-brand-panel__viewport"
      data-testid="auth-brand-panel__viewport"
      aria-live="polite"
    >
      <AuthBrandPanelSlide
        v-for="(slide, index) in slides"
        :key="slide.id"
        :slide="slide"
        :active="index === activeIndex"
      />
    </div>
    <div
      v-if="slides.length > 1"
      class="auth-brand-panel__dots"
      role="tablist"
      aria-label="Brand panel slides"
      data-testid="auth-brand-panel__dots"
    >
      <button
        v-for="(slide, index) in slides"
        :key="`dot-${slide.id}`"
        type="button"
        class="auth-brand-panel__dot"
        :class="{ 'auth-brand-panel__dot--active': index === activeIndex }"
        role="tab"
        :aria-selected="index === activeIndex ? 'true' : 'false'"
        :aria-label="`Go to slide ${index + 1}`"
        :data-testid="`auth-brand-panel__dot--${index}`"
        @click="goToSlide(index)"
      />
    </div>
  </aside>
</template>

<script>
import AuthBrandPanelSlide from './AuthBrandPanelSlide.vue';
import { AUTH_BRAND_PANEL_CAROUSEL_INTERVAL_MS } from './AuthBrandPanelUtils';

export default {
  name: 'AuthBrandPanel',
  components: {
    AuthBrandPanelSlide,
  },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: 0,
      carouselTimer: null,
      prefersReducedMotion: false,
    };
  },
  computed: {
    activeSlide() {
      return this.slides[this.activeIndex] || this.slides[0] || { heading: '' };
    },
    carouselLabel() {
      return this.activeSlide.heading || 'Brand panel';
    },
  },
  watch: {
    slides() {
      this.activeIndex = 0;
      this.restartCarousel();
    },
  },
  mounted() {
    this.prefersReducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.startCarousel();
  },
  beforeDestroy() {
    this.stopCarousel();
    this.activeIndex = 0;
  },
  methods: {
    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.activeIndex = index;
      this.restartCarousel();
    },
    nextSlide() {
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
    },
    startCarousel() {
      if (this.prefersReducedMotion || this.slides.length <= 1) return;
      this.stopCarousel();
      this.carouselTimer = window.setInterval(() => {
        this.nextSlide();
      }, AUTH_BRAND_PANEL_CAROUSEL_INTERVAL_MS);
    },
    stopCarousel() {
      if (this.carouselTimer) {
        window.clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }
    },
    restartCarousel() {
      this.stopCarousel();
      this.startCarousel();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AuthBrandPanel.scss';
</style>
